import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-diyerror",
  "use": "icon-diyerror-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-diyerror\"><path d=\"M512 512m-512 0a512 512 0 1 0 1024 0 512 512 0 1 0-1024 0Z\" fill=\"#EA0000\" p-id=\"8155\" /><path d=\"M661.44 306.56l66.56 66.496-147.84 147.712 147.84 147.776-66.56 66.56-147.776-147.84-147.712 147.84-66.56-66.56 147.712-147.776L299.392 373.12l66.56-66.56 147.712 147.712 147.84-147.712z\" fill=\"#FFFFFF\" p-id=\"8156\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol